import { SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SubRoutePartnersLayoutComponent } from './sub-route-partners-layout.component';

export type SubRoutePartnersDialogData = SubRouteAttributes;

/**
 * Full screen host for the sub route partners screen.
 *
 * It is kept separate from the periodicity modal on purpose: the two open from different buttons
 * in the routes list, so each one keeps its own entry point and its own size.
 */
@Component({
  selector: 'app-sub-route-partners-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    SubRoutePartnersLayoutComponent,
  ],
  template: `
    <div class="flex h-full flex-col overflow-hidden">
      <div class="flex shrink-0 justify-end px-4 py-2">
        <button mat-icon-button mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <app-sub-route-partners-layout
        class="min-h-0 flex-1"
        [subRouteId]="data._id.toString()"
      />
    </div>
  `,
})
export class SubRoutePartnersDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SubRoutePartnersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SubRoutePartnersDialogData
  ) {}
}
